import {
  createMultiStyleConfigHelpers,
  StyleThemingProps,
  useMultiStyleConfig,
} from '@chakra-ui/react'
import { MultiStyleType } from '@chakra-ui/styled-system'
import { themeColorSectionKeys } from '~/themes/colors/colors'
import { getName } from '~/utils/objectUtils'

import { phoneColorKeys } from './_colors'

const {
  FontColor: { Default: DefaultFontColor },
} = themeColorSectionKeys.defaults

const {
  PrimaryButton: {
    FontColor: PrimaryButtonFontColor,
    Background: PrimaryButtonBackground,
  },
} = themeColorSectionKeys.shared

const {
  TransferHeader: { Input: InputColors },
} = phoneColorKeys.Phone

export const enum TransferHeaderVariants {
  Default = 'default',
  Disabled = 'disabled',
}

const transferHeaderParts = [
  'container',
  'input',
  'inputRightElement',
  'iconButton',
  'icon',
] as const

const helpers = createMultiStyleConfigHelpers(transferHeaderParts)

export const TransferHeaderStyle = helpers.defineMultiStyleConfig({
  baseStyle: {
    container: {
      flexDirection: 'column',
      paddingBottom: '20px',
    },
    input: {
      height: '60px',
      backgroundColor: InputColors.Background,
      borderColor: InputColors.Border,
      color: DefaultFontColor,
      _placeholder: {
        color: InputColors.Placeholder.FontColor,
      },
    },
    inputRightElement: {
      paddingTop: '18px',
      paddingRight: '20px',
      gap: '4px',
    },
    iconButton: {
      borderRadius: 'full',
      background: PrimaryButtonBackground.Default,
      _hover: {
        background: PrimaryButtonBackground.Hover,
      },
      _active: {
        background: PrimaryButtonBackground.Hover,
      },
      transition: 'opacity 0.2s ease-out',
    },
    icon: {
      color: PrimaryButtonFontColor.Default,
      boxSize: '24px',
    },
  },
  variants: {
    [TransferHeaderVariants.Default]: {
      iconButton: {
        opacity: '1',
        _hover: {
          cursor: 'pointer',
        },
      },
    },
    [TransferHeaderVariants.Disabled]: {
      iconButton: {
        opacity: '0',
        _hover: {
          cursor: 'default',
        },
      },
    },
  },
  defaultProps: {
    variant: TransferHeaderVariants.Default,
  },
})

export const useTransferHeaderStyle = (props?: StyleThemingProps) => {
  return useMultiStyleConfig(
    getName({ TransferHeaderStyle }),
    props,
  ) as MultiStyleType<typeof transferHeaderParts>
}
